const luhn = value => 97 - ((parseInt(value)) % 97);
export default luhn;